import Counter from '../Counter'; // Adjust path as necessary

const QualityStatsSection = () => (
  <>
    <section className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-c82d658 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="c82d658" data-element_type="section">
      <div className="elementor-container elementor-column-gap-default">
        <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-285b8a85" data-id="285b8a85" data-element_type="column">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-6e29d20a wd-width-100 elementor-widget elementor-widget-wd_title" data-id="6e29d20a" data-element_type="widget" data-widget_type="wd_title.default">
              <div className="elementor-widget-container">
                <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-primary wd-title-style-bordered wd-title-size-default text-center">
                  <div className="title-subtitle subtitle-color-primary subtitle-style-default wd-fontsize-xs">
                    imw-eduCATION
                  </div>
                  <div className="liner-continer">
                    <h4 className="woodmart-title-container title wd-fontsize-l">Our quality</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-78125a39 wd-section-stretch_row_content elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="78125a39" data-element_type="section">
      <div className="elementor-container elementor-column-gap-extended">
        <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-525b0fe1 color-scheme-light" data-id="525b0fe1" data-element_type="column" data-settings='{"background_background":"classic"}'>
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-7ca5154f elementor-widget elementor-widget-wd_counter" data-id="7ca5154f" data-element_type="widget" data-widget_type="wd_counter.default">
              <div className="elementor-widget-container">
                <div className="woodmart-counter counter-large text-center color-scheme-light">
                  <Counter finalValue="634" />
                  <div className="counter-label">Rank Holders</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-12746429 color-scheme-light" data-id="12746429" data-element_type="column" data-settings='{"background_background":"classic"}'>
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-3dd31443 elementor-widget elementor-widget-wd_counter" data-id="3dd31443" data-element_type="widget" data-widget_type="wd_counter.default">
              <div className="elementor-widget-container">
                <div className="woodmart-counter counter-large text-center color-scheme-light">
                  <Counter finalValue="52" />
                  <div className="counter-label">No of events</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-7c2b7583 color-scheme-light" data-id="7c2b7583" data-element_type="column" data-settings='{"background_background":"classic"}'>
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-67856b7e elementor-widget elementor-widget-wd_counter" data-id="67856b7e" data-element_type="widget" data-widget_type="wd_counter.default">
              <div className="elementor-widget-container">
                <div className="woodmart-counter counter-large text-center color-scheme-light">
                  <Counter finalValue="1000" />
                  <div className="counter-label">No of Students</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-45a0df91 color-scheme-light" data-id="45a0df91" data-element_type="column" data-settings='{"background_background":"classic"}'>
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-164844a2 elementor-widget elementor-widget-wd_counter" data-id="164844a2" data-element_type="widget" data-widget_type="wd_counter.default">
              <div className="elementor-widget-container">
                <div className="woodmart-counter counter-large text-center color-scheme-light">
                  <Counter finalValue="5" />
                  <div className="counter-label">Year of Edu</div> {/* Corrected typo from HTML "Yearf od Edu" */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default QualityStatsSection;